import { connect } from 'react-redux'
import Timeline from '../components/Timeline'
import { changeYear, selectTopic } from '../redux/modules/timeline'
import { timelineSelector, getSelectedTopicID } from '../redux/selector'

const mapStateToProps = (state, { show }) => ({
  ...timelineSelector(state),
  selectedID: getSelectedTopicID(state),
})

const mapDispatchToProps = dispatch => ({
  onTopicChange: id => {
    dispatch(selectTopic({ id }))
  },
  onYearChange: year => {
    dispatch(changeYear(year))
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Timeline)
